import React, { useState, useContext, useEffect } from 'react'
import { v4 as uuid } from 'uuid'

import CardDetail from '../CardDetail'
import SelectedPlanContext from '../../context/SelectedPlan'
import PlansContext from '../../context/Plans'
import './PickerCard.scss'

/**
 * Component for showing the details for each ZealStream subscription plan
 *
 * @component
 * @example
 * const selected = false // selected has a value of true or false
 * const name = 'Plan Name Here' // plan name can be any string
 * const price = 21.99 // price can be any number
 * const details = ["detail 1", "detail 2", "detail 3"] // details should be an array of strings
 * const summary = "blah blah blah" // summary can be any string
 * return (
 *   <PickerCard selected={selected} name={name} price={price} details={details} summary={summary} />
 * )
*/

const PickerCard = ({ selected, name, price, details, summary }) => {

    const [open, setOpen] = useState(false)

    const { selectedPlan, setSelectedPlan } = useContext(SelectedPlanContext)
    const { plans } = useContext(PlansContext)

    const handlePlanChange = () => setSelectedPlan(plans.filter(plan => plan.name === name)[0])

    return (

        <div className={`card ${selected ? 'selected' : ''}`}>

            <div className={`card-header border-bottom-0 w-100 d-flex align-items-center justify-content-between ${selected ? 'text-white' : 'text-black'}`}>

                <div>
                    <input type="radio" name="planRadios" className={`form-check-input me-2`} id={`${name}Radio`} onClick={handlePlanChange} checked={selected} readOnly/>
                    <label htmlFor={`${name}Radio`} className="form-check-label">
                        <h5 className="mb-0">{selected ? 'Current Plan' : (selectedPlan.metadata.price_for_fe > price ? `Switch to ${name}` : `Upgrade to ${name}`)}</h5>
                    </label>
                </div>

                <a href={`#${name}Details`} data-bs-toggle="collapse" onClick={() => setOpen(!open)} role="button">
                    <img className={`${open ? 'up-arrow' : '' }`} src="/images/arrow_down.svg" alt={`Open ${name} Plan`} />
                </a>

            </div>

            <div className="card-body">

                <h5 className="card-title pb-3">{name}</h5>

                <p className="card-text">
                    
                    {name !== "Personal" ? (
                        <>
                            <span className="price">${price}</span>
                            <span className="price-frequency">/month</span>
                        </>
                    ) : (<span className="price">Free <span className="stipulation">*99¢ Initial Setup Fee</span></span>)}

                </p>

                <div id={`${name}Details`} className="collapse">

                    <p className="card-text">{summary}</p>

                    <hr />

                    {details.map(detail => <CardDetail key={uuid()} detail={detail} />)}

                </div>

            </div>

        </div>

    )

}

export default PickerCard